export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20editorial%20photojournalism%20of%20a%20large%20energetic%20crowd%20gathered%20in%20an%20open%20public%20plaza%20at%20dusk%20from%20a%20high%20angle%2C%20hundreds%20of%20people%20watching%20a%20bright%20lit%20stage%20and%20giant%20screen%20in%20the%20distance%2C%20warm%20amber%20and%20coral%20city%20lights%2C%20string%20lights%20and%20market%20tents%2C%20terracotta%20and%20cream%20atmosphere%2C%20soft%20haze%2C%20documentary%20news%20photo%20style%2C%20high%20detail%2C%20cohesive%20warm%20color%20grade&width=1600&height=900&seq=hero-001&orientation=landscape"
        alt="91群众围观现场人群聚集全景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>

      <div className="relative z-10 w-full px-4 pt-24 pb-14 text-center md:px-6 md:pt-28">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center">
          <span className="animate-rise inline-flex items-center gap-1.5 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs tracking-wide text-background-50 backdrop-blur-sm">
            <i className="ri-record-circle-line text-accent-300"></i>
            今日围观现场 · 实时更新
          </span>

          <h2 className="animate-rise delay-100 mt-7 font-serif text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-tight">
            人群聚集的地方
            <br className="hidden md:block" />
            总有最新瓜点正在发生
          </h2>

          <p className="animate-rise delay-200 mt-6 max-w-xl text-sm leading-relaxed text-background-50/85 md:text-base">
            现场聚集情况、群众反应、事件进展——图文记录第一视角。91群众带你身临其境，
            隔着屏幕也能把热闹看得明明白白。
          </p>

          <div className="animate-rise delay-200 mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#scene"
              className="inline-flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
            >
              <i className="ri-eye-line"></i>
              进入现场
            </a>
            <a
              href="#topics"
              className="inline-flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-fire-line"></i>
              看最新瓜点
            </a>
          </div>

          <div className="animate-rise delay-300 mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-background-50/90">
            <div className="flex items-center gap-2 text-sm">
              <span className="text-xl font-bold text-accent-300">86</span>
              <span className="text-xs text-background-50/70">今日现场进行中</span>
            </div>
            <div className="hidden h-4 w-px bg-background-50/25 sm:block"></div>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-xl font-bold text-accent-300">12,600+</span>
              <span className="text-xs text-background-50/70">条图文围观记录</span>
            </div>
            <div className="hidden h-4 w-px bg-background-50/25 sm:block"></div>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-xl font-bold text-accent-300">9.8 万</span>
              <span className="text-xs text-background-50/70">今日围观热度</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}